import React from 'react'
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import {extractIndividualErrors} from 'validation'
import theme from './FileUploader.scss';
import deleteImg from '../recycle.jpg';
import lupe from './lupe.png';
import Tooltip from 'common/Tooltip'
import ErrorTooltip from 'common/ErrorTooltip'
import {putAll} from 'utils/Array'
import {getMessage as msg} from 'MessageBundle'

const FILE_LIMIT = 10;

export default class FileUploader extends React.Component {

    fileLimitNotReached = true;

    /**
     * The function is necessary to allow user add the files that were removed using delete button.
     */
    addFileEvent = function () {
        this.value = "";
    };

    componentDidMount() {
        this.input.addEventListener('click', this.addFileEvent, false);
    }

    componentWillUnmount() {
        this.input.removeEventListener('click', this.addFileEvent, false);
    }

    handleFileSelect = (e) => {
        if (e.target.files.length + this.props.value.length <= FILE_LIMIT) {
            const updatedList = this.distinctFilesArray(putAll(this.props.value, Array.from(e.target.files)));
            this.props.onChange(updatedList);
            this.fileLimitNotReached = updatedList.length < FILE_LIMIT;
        }
    };

    //it required only for autotests, it's not business demand. Complexity in worst case is O(n^2), but it should not be
    //problem for perfomance because of small counts of elemens in file array.
    distinctFilesArray = (array) => {
        let uniqueArray = [];
        array.forEach(file => {
            if (!this.containsFile(file, uniqueArray)) {
                uniqueArray.push(file)
            }
        })

        return uniqueArray;
    }

    containsFile = (file, array) => {
        return array.filter(f => {
            return file.name == f.name && file.size == f.size && file.type == f.type && file.lastModified == f.lastModified;
        }).length == 1;
    }

    removeItem = (index) => () => {
        const updatedList = update(this.props.value, {$splice: [[index, 1]]});
        this.props.onChange(updatedList);
        this.fileLimitNotReached = updatedList.length < FILE_LIMIT;
    };

    previews = () => {
        return this.props.value.map((file, index) => {
            return (
                <li key={index}>
                    <span id={this.props.id + '-item-' + index}>{file.name}</span>
                    <button id={this.props.id + '-delete-btn-' + index} className={theme.btnDelete} onClick={this.removeItem(index)}>
                        <img src={deleteImg} role="presentation"/>
                    </button>
                </li>
            )
        });
    };

    selectFile = (e) => {
        e.preventDefault();
        this.input.click(e);
    };

    render() {
        let filesCount = this.props.value.length;
        let lastFileName = filesCount >= 1 ? this.props.value[filesCount - 1].name : '';
        const errorMessages = extractIndividualErrors(this.props.errorMessages, this.props.name);
        return (
            <div id={this.props.id + '-wrapper'} className={this.props.className}>
                <div className={theme.row}>
                    <label htmlFor="documentsList-file">Anlage hochladen:
                        <Tooltip for={this.props.id}
                            value={this.props.authenticated ? msg("fileUploader.authenticatedToolTip") : msg("fileUploader.notAuthenticatedToolTip")}/>
                    </label>
                    <input id="documentsList-file" type="file" accept={this.props.allowedTypes.toString()} multiple="multiple"
                        tabIndex="-1" ref={(input) => this.input = input} className={theme.hiddenInput} onChange={this.handleFileSelect}/>
                    <input id={this.props.id + '-lastFileName'} type='text' value={lastFileName}/>
                    <button id={this.props.id} onClick={this.selectFile} disabled={!this.fileLimitNotReached}>
                        <img src={lupe} alt="" role="presentation"/>
                        Durchsuchen
                    </button>
                </div>
                <div className={theme.filesGroupWrap}>
                    <span className={theme.filesGroupSum}>
                        Anlagen zur Reklamation ({filesCount})
                    </span>
                    <div className={errorMessages.length > 0 ?  theme.filesGroup + " " +theme.filesGroupError : theme.filesGroup}>
                        <ul>
                            {this.previews()}
                        </ul>
                    </div>
                    {errorMessages.length > 0 ? <ErrorTooltip for={this.props.id} value={errorMessages}/> : ""}
                </div>
            </div>
        )
    }
}

FileUploader.propTypes = {

    /**
     * Id of the component.
     */
    id: PropTypes.string.isRequired,

    /**
     * Displayed message when file with incorrect size was uploaded
     */
    incorrectSizeMessage: PropTypes.string,

    /**
     * Displayed message when file with incorrect type was uploaded
     */
    incorrectTypeMessage: PropTypes.string,

    /**
     * CSS class name
     */
    className: PropTypes.string,

    /**
     * Function, called on changing file list
     */
    onChange: PropTypes.func,

    /**
     * Flag for TVPP or External user
     */
    authenticated: PropTypes.bool,

    /**
     * Files array
     */
    value: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/common/FileUploader/index.js